var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      style: _vm.$props.vertical ? "display: grid" : undefined,
      attrs: { dense: "" },
    },
    [
      _c(
        "v-col",
        { attrs: { cols: _vm.$props.cols } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Category",
              items: _vm.sortedCategories,
              "prepend-inner-icon": "mdi-filter-outline",
              "item-text": "name",
              "item-value": "id",
              "hide-details": "auto",
              "background-color": "input",
              dense: "",
              clearable: ["pricechopper", "alliance-retail-group"].includes(
                _vm.tenant
              )
                ? _vm.isAdminUser
                : true,
              outlined: "",
            },
            model: {
              value: _vm.value.category,
              callback: function ($$v) {
                _vm.$set(_vm.value, "category", $$v)
              },
              expression: "value.category",
            },
          }),
        ],
        1
      ),
      _vm.subcategories.length > 0
        ? _c(
            "v-col",
            { attrs: { cols: _vm.$props.cols } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Subcategory",
                  items: _vm.subcategories,
                  "prepend-inner-icon": "mdi-filter-outline",
                  "item-text": "name",
                  "item-value": "id",
                  "hide-details": "auto",
                  "background-color": "input",
                  dense: "",
                  clearable: "",
                  outlined: "",
                },
                model: {
                  value: _vm.value.subcategory,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "subcategory", $$v)
                  },
                  expression: "value.subcategory",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.subtypes.length > 0
        ? _c(
            "v-col",
            { attrs: { cols: _vm.$props.cols } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Subtype",
                  items: _vm.subtypes,
                  "prepend-inner-icon": "mdi-filter-outline",
                  "item-text": "name",
                  "item-value": "id",
                  "hide-details": "auto",
                  "background-color": "input",
                  dense: "",
                  clearable: "",
                  outlined: "",
                },
                model: {
                  value: _vm.value.subtype,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "subtype", $$v)
                  },
                  expression: "value.subtype",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-col",
        { attrs: { cols: _vm.$props.cols } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Status",
              "prepend-inner-icon": "mdi-filter-outline",
              items: _vm.statuses,
              "item-text": "name",
              "item-value": "id",
              dense: "",
              outlined: "",
              "hide-details": "auto",
              "background-color": "input",
              clearable: "",
            },
            model: {
              value: _vm.value.status,
              callback: function ($$v) {
                _vm.$set(_vm.value, "status", $$v)
              },
              expression: "value.status",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }